<template>
  <div class="catalog-product__item" @click="$emit('select', imageIndex)">
    <div class="catalog-product__image">
      <div v-if="selectable && imageIndex !== 0" class="image-selector image-selector__left" @click.stop="scrollLeft()">
        <base-icon icon="right-arrow-cell" style="transform: rotate(180deg); width: 8px;" />
      </div>
      <img
        v-srcset
        class="catalog-product__image"
        :class="{'catalog-product__image--selected': images[imageIndex] && images[imageIndex].selected}"
        :src="images[imageIndex] && images[imageIndex].image_url ? images[imageIndex] && images[imageIndex].image_url : '/img/blank-product.png'"
        alt=""
      >
      <div v-if="selectable && imageIndex !== images.length - 1" class="image-selector image-selector__right" @click.stop="scrollRight()">
        <base-icon icon="right-arrow-cell" style="width: 8px;" />
      </div>
    </div>
    <!-- Selected icon -->
    <div
      v-if="images[imageIndex] && images[imageIndex].selected"
      class="catalog-product__icon"
      style="z-index: 999;"
    >
      {{ images[imageIndex].number }}
    </div>
    <div
      v-if="images[imageIndex] && selectable && !images[imageIndex].selected"
      class="catalog-product__icon"
      style="background-color: unset !important; padding-top: unset !important;"
    >
      <base-icon icon="blank-checkobox" style="width: 20px !important;" />
    </div>
    <div class="catalog-product__info">
      <!-- Brand name -->
      <div
        class="catalog-product__brand"
      >
        {{ brand && !isMonobrand ? brand : title }}
      </div>

      <!-- Title -->
      <div
        v-if="brand && !isMonobrand"
        class="catalog-product__title"
      >
        {{ title }}
      </div>
      <!-- Price or formatted_price -->
      <div class="d-flex align-items-center">
        <div v-if="sale_display" class="catalog-product__price">
          <span class="catalog-product__price__old">
            {{ formatted_price }}
          </span>
          <span class="catalog-product__price__sale"> {{ sale_display }}</span>
        </div>
        <div v-else>
          <div
            class="catalog-product__price"
          >
            {{ formatted_price }}
          </div>
        </div>
        <span
          v-if="stockState && stock_state.toUpperCase() !== 'UNKNOWN' && stockState !== 'in_stock' && stockState !== 'IN STOCK'"
          class="d-flex align-items-center"
        >
          <span class="catalog-product__dash">-</span>
          <div
            v-if="stockState === 'out_of_stock' || stockState === 'OUT OF STOCK'"
            class="catalog-product__stock-status"
          >
            Out of Stock
          </div>
          <div
            v-if="stockState === 'unknown' || stockState === 'UNKNOWN'"
            class="catalog-product__stock-status coming"
          >
            Coming Soon
          </div>
        </span>
      </div>

      <div v-if="sku" class="catalog-product__sku">
        ID: {{ external_id }}
      </div>

      <!-- Colors -->
      <template v-if="colors.length > 1">
        <div class="catalog-product__colors">
          {{ $tc('inventory.color', colors.length) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CatalogProductItem',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    sku: {
      type: String,
      default: null,
    },
    brand: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    price: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    formatted_price: {
      type: String,
      default: null,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    stockState: {
      type: String,
      default: '',
    },
    number: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line
    sale_display: {
      type: [String, Boolean],
      default: null,
    },
    // eslint-disable-next-line
    external_id: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    imageIndex: 0,
  }),
  computed: {
    isMonobrand() {
      return this.$store?.state?.account?.user?.profile?.institution?.is_monobrand;
    },
  },
  methods: {
    scrollLeft() {
      this.imageIndex--;
    },
    scrollRight() {
      this.imageIndex++;
    },
  },
};
</script>

<style lang="scss" scoped>

.image-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 45%;
  // bottom: 0;
  background: rgba(80, 80, 80, 0.2);
  width: 28px;
  height: 28px;
  z-index: 2;

  &__left {
    background-color: unset;
    left: 0;
  }

  &__right {
    background-color: unset;
    right: 0;
  }
}

.catalog-product{
  &__item{
    max-width: 225px;
    cursor: pointer;
    position: relative;
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;

    &:not(:hover) .image-selector {
      display: none;
    }
  }
  &__image{
    border-radius: 4px;
    position: relative;
    object-fit: cover;
    width: 100%;
    height: auto;
    user-select: none;
    aspect-ratio: 0.75;

    &--selected {
      box-shadow: 0 0 0 2px $primary;
    }

    &--placeholder {
      text-align: center;
      padding-top: 100px;
    }

  }
  &__brand{
    // @extend %silka-12-bold;
    font-family: 'SilkaMedium';
    font-size: 14px;
    font-weight: 400;
    color: $dark-black;
  }
  &__title,
  &__price{
    font-family: 'SilkaLight';
    font-size: 14px;
    &__sale{
      margin-left: 4px;
    }
    &__old{
      text-decoration: line-through;
    }
  }
  &__colors{
    @extend %silka-12-light;
  }
  &__stock-status{
    font-family: $font-family-sans-serif-medium;
    font-weight: 500;
    font-size: 0.625rem;
    color: $red;
    &.coming{
      color: $dark-black;
    }
  }
  &__dash{
    padding: 0 4px;
    font-family: $font-family-sans-serif-light;
  }
  &__title{
    color: $dark-black;
  }
  &__colors{
    color: $gray;
  }
  &__price{
    color: $dark-black;
    font-size: 0.875rem;
  }
  &__sku {
    font-family: 'SilkaLight';
    color: #767676;
    font-size: 0.75rem;
  }
  &__info{
    // margin-top: 10px;
    display: grid;
    grid-row-gap: 8px;
  }
  &__icon {
    padding-top: 2px;
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    background-color: $primary;
    top: 8px;
    right: 8px;
    border-radius: 4px;
    color: white;
    font-size: 0.75rem;
    text-align: center;
    z-index: 5;
    img{
      width: 18px;
      position: relative;
      left: -0.5px;
    }
  }
}
</style>
